<mh-alerts-wrapper>
	<mh-core-lib-content>
		<ng-container head>
			<mh-core-lib-header-content (click)="headerAreaClicked()">
				<section mhFilterBar>
					<article mhFilterGroup>
						<article>
							<mh-core-lib-datepicker
									[currentDates]="currentDates"
									[currentFilter]="currentFilterDate"
									(datepickerUpdated)="handleDatepickerUpdated($event)">
							</mh-core-lib-datepicker>
						</article>
						<article *ngIf="['otas', 'reviews'].includes(activeRoute)">
							<mh-competitors-selector id="selectorCompetitor"></mh-competitors-selector>
						</article>
            <article *ngIf="activeRoute === 'reviews'">
              <mh-core-lib-new-reviews-filter id="filtersReviews"></mh-core-lib-new-reviews-filter>
            </article>
					</article>
					<!-- El reporte no se muestra bajo lg; se oculta el grupo entero para que no sume espacio vacío en la barra -->
					<article mhFilterGroup class="tw-hidden lg:tw-flex">
            <mh-core-lib-actions-wrapper
                [slug]="reportSlug"
              >
              <mh-core-lib-report-button
                  [type]="activeReport"
                  [activeEmail]="false"
                  [chain]="chain"
                  >
              </mh-core-lib-report-button>
            </mh-core-lib-actions-wrapper>
					</article>
				</section>
			</mh-core-lib-header-content>
		</ng-container>

		<ng-container main-content>
			<router-outlet></router-outlet>
		</ng-container>
	</mh-core-lib-content>
</mh-alerts-wrapper>
